import styled from 'styled-components'
import { Tab } from '@headlessui/react'
import Link from 'next/link'

export const TabButton = styled(Tab)`
  border: none;
  outline: none;
  background: white;
  font-size: 20px;
  font-weight: var(--font-regular);
  padding: 12px 32px;
  line-height: 1;
  top: -1px;
  position: relative;
  cursor: pointer;
  color: var(--brand-secondary);

  &:hover {
    color: var(--brand-primary);
  }

  &[aria-selected='true'] {
    margin-bottom: -1px;
    border-bottom: 2px solid #fac532;
    font-weight: var(--font-bold);
    z-index: 2;
  }

  @media (max-width: 767px) {
    font-size: 16px;
    padding: 10px 15px;
  }
`

export const TabList = styled(Tab.List)`
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 30px;
  row-gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 767px) {
    width: calc(100% + 24px);
  }
`
export const TabContainer = styled(Tab.Panel)`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`

export const StyledLink = styled(Link)`
  text-decoration: underline;
  color: black;
  font-weight: var(--font-regular);
`
